import { render, staticRenderFns } from "./CreatePreset.vue?vue&type=template&id=fed63ca6&scoped=true"
import script from "./CreatePreset.vue?vue&type=script&lang=js"
export * from "./CreatePreset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed63ca6",
  null
  
)

export default component.exports